import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import * as React from "react";
import { useCallback, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import DynamicFormWithoutSave from "../../components/dynamicscreens/DynamicFormWithoutSave";
import { noInternetMsg, serverMsg } from "../../config/messageconstant";
import { auditJson } from "../../DynamicFormsJson/MastersJSON/audit";
import { getEntityMaster } from "../../Slice/entityMaster.slice";
import { showLoador, showNotification } from "../Landing/Landing.slice";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": { padding: theme.spacing(2) },
  "& .MuiDialogActions-root": { padding: theme.spacing(1) },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;
  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const AddQuestion = ({ dataToSave, value, open, handleCloses, onSave, getEntityMaster }) => {

  const defaultFieldMeta = useMemo(
    () =>
      value == 2
        ? auditJson.fieldMetaForQestionForAreaExploration
        : auditJson.fieldMetaForQestion,
    [value]
  );

  const [fieldMeta, setFieldMeta] = React.useState(defaultFieldMeta);

  const initialDynamicMasterData = useMemo(() => {
    if (value == 2) {
      return {
        optionTypeList: [
          { id: "1", name: "Optional" },
          { id: "2", name: "Multi Select" },
        ],
      };
    }
    if (value == 4) {
      return {
        optionTypeList: [
          { id: "0", name: "Description" },
          { id: "1", name: "Optional" },
          { id: "2", name: "Multi Select" },
          { id: "3", name: "Entity Based" },
        ],
      };
    }
    return {
      optionTypeList: [
        { id: "0", name: "Description" },
        { id: "1", name: "Optional" },
        { id: "2", name: "Multi Select" },
      ],
    };
  }, [value]);

  const [dynamicMasterData, setDynamicMasterData] = React.useState(initialDynamicMasterData);

  const handleClose = useCallback(() => {
    handleCloses();
  }, [handleCloses]);

  useEffect(() => {
    setFieldMeta(defaultFieldMeta);
  }, [defaultFieldMeta]);

  useEffect(() => {
    if (dataToSave && Object.keys(dataToSave).length > 0) {
      setFieldMeta(
        dataToSave.optionType == 3
          ? auditJson.fieldMetaForChefWorking
          : defaultFieldMeta
      );
    }
  }, [dataToSave, defaultFieldMeta]);

  useEffect(() => {
    setDynamicMasterData(initialDynamicMasterData);
  }, [initialDynamicMasterData]);

  useEffect(() => {
    const fetchData = async () => {
      if (value == 4) {
        if (navigator.onLine) {
          showLoador({ loador: true });
          await getEntityMaster().then(
            ({ response, success }) => {
              if (success) {
                setDynamicMasterData((prev) => ({ ...prev, itemList: response }));
              } else {
                showNotification({ msg: serverMsg, severity: "error" });
              }
            }
          );
          showLoador({ loador: false });

        } else {
          showNotification({ msg: noInternetMsg, severity: "error" });
        }
      }
    };

    fetchData();
  }, [value]);

  const submitHandler = useCallback(
    (dataToSave) => {
      onSave(dataToSave);
    },
    [onSave]
  );

  const setDataToForm = useCallback(
    (data) => {
      setFieldMeta(
        data.optionType == 3 ? auditJson.fieldMetaForChefWorking : defaultFieldMeta
      );
    },
    [defaultFieldMeta]
  );

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      fullWidth
      maxWidth="lg"
    >
      <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
        Add Question
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <DynamicFormWithoutSave
          showTitle={false}
          showBackToList={true}
          DataToSet={[]}
          defaultData={dataToSave}
          getDataForm={true}
          setDataToForm={setDataToForm}
          dynamicMasterData={dynamicMasterData}
          getByIdApi={false}
          callApi={false}
          screenTitle={auditJson.screenTitle}
          fieldMeta={fieldMeta}
          showCancel={auditJson.showCancel}
          apiBaseURL={auditJson.apiBaseURL}
          showSaveNextBtn={auditJson.showSaveNextBtn}
          showSaveBtnMain={false}
          showSaveBtn={true}
          saveBtnText={"Add"}
          onSave={submitHandler}
        />
      </DialogContent>
    </BootstrapDialog>
  );
};
const mapStateToProps = (state) => ({ feedBack: state.feedBack });
const mapDispatchToProps = {
  showLoador,
  showNotification,
  getEntityMaster,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddQuestion);